import { createContext, use } from "react";

import type { RouterOutputs } from "@/lib/trpc";

type User = RouterOutputs["user"]["getMe"];
type StreamUser = RouterOutputs["message"]["getStreamChatUser"];

export const UserContext = createContext<{ user: User; streamUser: StreamUser } | null>(null);

export const useMe = () => {
  const me = use(UserContext);
  if (!me) {
    throw new Error("Cannot use `useMe` outside of a `<UserContextProvider />`");
  }
  return me;
};
